/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IProductAttributeType } from 'app/shared/model/product-attribute-type.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';

export interface IProductAttribute {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  value?: string | null;
  comments?: string | null;
  productId?: string | null;
  productType?: keyof typeof ProductType | null;
  type?: IProductAttributeType | null;
  pharmacy?: IPharmacy | null;
}

export const defaultValue: Readonly<IProductAttribute> = {
  active: false,
};
